import type { DraftSteps } from './types';

const STEP_TITLE = {
  select_product: 'Select product',
  payout_request: 'Payout request',
  debtor: 'Debtor',
  ultimate_debtor: 'Sender',
  creditor: 'Receiver',
  creditor_account: 'Receiver bank',
  summary: 'Summary',
  intermediary_agent: 'Intermediary agent',
  intermediary_agent_account: 'Intermediary agent account',
  review_and_submit: 'Review details'
} as const;

export const formatStepTitle = (step: DraftSteps) => {
  return STEP_TITLE[step];
};
